import React  from 'react';
import UsersComponentProto from './users-proto/users-proto';

export default function renderDateInFormNew(id, props) {
    return <UsersComponentProto renderMode="form-new" id={id} {...props} />;
}